import { Injectable } from '@angular/core';
import { IPeriodResults } from '@interfaces/IPeriodResults';
import { IAppState } from '@myStore/app.state';
import {
  EStudentsPerformanceActions,
  GetStudentsPerformancePeriodFailure,
  GetStudentsPerformancePeriodRequest,
  GetStudentsPerformancePeriodSuccess,
} from '@myStore/students-performance/students-perfomance.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { StudentsPerformanceService } from '@services/students-performance/students-performance.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class StudentsPerformanceEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _studentsPerformanceService: StudentsPerformanceService
  ) {}

  $getStudentsPerformancePeriod = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetStudentsPerformancePeriodRequest>(
          EStudentsPerformanceActions.GetStudentsPerformancePeriodRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._studentsPerformanceService
            .getStudentsPerformancePeriod(
              action.periodId,
              action.options?.qParams
            )
            .pipe(
              map((studentsPerformance: IPeriodResults) => {
                this._store.dispatch(
                  new GetStudentsPerformancePeriodSuccess(studentsPerformance)
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении успеваемости возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(
                  new GetStudentsPerformancePeriodFailure(err.error)
                );
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
